import PropTypes from 'prop-types'
import { Navigate } from 'react-router-dom'

import useAuth from '../hooks/useAuth'

import { PATH_DASHBOARD } from '../routes/paths'

GuestGuard.propTypes = {
  children: PropTypes.node,
}

export default function GuestGuard({ children }) {
  const { isAuthenticated, user } = useAuth()

  if (isAuthenticated) {
    if (user.role.includes('SUPERADMIN')) {
      return <Navigate to={PATH_DASHBOARD.general.app} />
    } else if (user.role.includes('CONFORMERADMIN')) {
      return <Navigate to={PATH_DASHBOARD.admin.conformer} />
    } else if (user.role.includes('STARTUPADMIN')) {
      return <Navigate to={PATH_DASHBOARD.admin.startup} />
    } else if (user.role.includes('INVESTORADMIN')) {
      return <Navigate to={PATH_DASHBOARD.admin.investor} />
    } else if (user.role.includes('SUPERVISOR')) {
      return <Navigate to={PATH_DASHBOARD.admin.supervisor} />
    }
  }

  return <>{children}</>
}
